'use strict';

var HistoryDrawerCustomRenderersFactory = function HistoryDrawerCustomRenderersFactory(UserSecureService) {
  var historyItems = [];
  var appliedByRenderer = function appliedByRenderer(history) {
    historyItems = history;
    return function (row, columnfield, value, defaulthtml) {
      if (!historyItems[row].appliedByRuleId) {
        var User = UserSecureService.getUserDisplayNameFromId(value);
        if (User) {
          return defaulthtml.replace('>' + value + '<', '>' + User.getDisplayName() + '<');
        } else {
          return defaulthtml;
        }
      }
      var technicalId = historyItems[row].appliedByRuleId;
      return defaulthtml.replace('>' + value + '<', '><a href="#" class="grid-cell-link readOnlyRule" data-uid="' + technicalId + '" >' + value + '</a><');
    };
  };
  return {
    appliedByRenderer: appliedByRenderer
  };
};
HistoryDrawerCustomRenderersFactory.$inject = ['UserSecureService', 'RuleNavigationService'];
module.exports = HistoryDrawerCustomRenderersFactory;